// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"32":"8533e613be326831f3c9","548":"6ffcb3728d3ee94964a9"}[chunkId] + ".css";
};